import { blocks } from '@yola/ws-sdk';
import { SURFACES_ATTRIBUTE } from '../../constants/display-options';

function hasOptionWithValue(surfaceDisplayOption, surfaceOptionValue) {
  return surfaceDisplayOption.options.some(
    (surfaceOption) => surfaceOption.value === surfaceOptionValue
  );
}

function findOptionWithIndex(surfaceDisplayOptionIndex, surfaceDisplayOptions) {
  return surfaceDisplayOptions.find(
    (displayOption) => surfaceDisplayOptionIndex === displayOption.index
  );
}

const setMatchingSurface = ({ displayOptions, destinationBlockNode }) => {
  const destinationBlockDisplayOptions = blocks.accessors
    .getDisplayOptionsForElement(destinationBlockNode)
    .filter((option) => !option.hidden);

  const destinationSurfaceOptions = destinationBlockDisplayOptions.filter(
    (option) => option.attribute === SURFACES_ATTRIBUTE
  );
  const sourceDisplayOptions = displayOptions.filter(
    (option) => option.attribute === SURFACES_ATTRIBUTE
  );

  if (!destinationSurfaceOptions.length || !sourceDisplayOptions.length) {
    return;
  }

  const [primaryDestinationSurfaceOption] = destinationSurfaceOptions;
  const [primarySourceSurfaceOption] = sourceDisplayOptions;

  const isDestinationIndexed = Number.isInteger(primaryDestinationSurfaceOption.index);
  const isSourceIndexed = Number.isInteger(primarySourceSurfaceOption.index);
  const isOnlyOneSourceSurfaceOption = sourceDisplayOptions.length === 1;

  const surfaceValues = [];

  if (isDestinationIndexed && !isOnlyOneSourceSurfaceOption) {
    destinationSurfaceOptions.reduce((surfaceArray, destDisplayOption) => {
      const surfaces = surfaceArray;

      const sourceDisplayOption = isSourceIndexed
        ? findOptionWithIndex(destDisplayOption.index, sourceDisplayOptions)
        : primarySourceSurfaceOption;

      if ((!sourceDisplayOption || !sourceDisplayOption.value) && !destDisplayOption.toggleable) {
        const [prevSurfaceValue] = surfaces;

        surfaces[destDisplayOption.index] = hasOptionWithValue(destDisplayOption, prevSurfaceValue)
          ? prevSurfaceValue
          : destDisplayOption.options[0].value;
      } else {
        surfaces[destDisplayOption.index] =
          !sourceDisplayOption.value ||
          hasOptionWithValue(destDisplayOption, sourceDisplayOption.value)
            ? sourceDisplayOption.value
            : destDisplayOption.options[0].value;
      }

      return surfaces;
    }, surfaceValues);
  } else {
    const sourceDisplayOption = isSourceIndexed
      ? findOptionWithIndex(0, sourceDisplayOptions)
      : primarySourceSurfaceOption;

    surfaceValues.push(
      hasOptionWithValue(primaryDestinationSurfaceOption, sourceDisplayOption.value)
        ? sourceDisplayOption.value
        : primaryDestinationSurfaceOption.options[0].value
    );
  }

  const surfaceValue = surfaceValues.filter(Boolean).join(' ');

  if (surfaceValue) {
    destinationBlockNode.setAttribute(SURFACES_ATTRIBUTE, surfaceValue);
  }
};

export default setMatchingSurface;
